module.exports = __webpack_public_path__ + "static/media/users.f31f442a.svg";